module.exports = __webpack_public_path__ + "static/media/card3_4.f82bcf14.png";